import React from 'react';
import { useVendorListTableInit } from './useVendorListTableInit';
import { useVendorListTableState } from './useVendorListTableState';
import { useVendorData } from './useVendorData';
import { useVendorListStore } from '../pagehooks/useVendorListStore';
import { ngDelegate } from '../../../../core/services/ng.delegate';
import TableBody from '../../../../core/table/TableBody';
import TableCreateEntityButton from '../../../../core/table/TableCreateEntityButton';
import TableHead from '../../../../core/table/TableHead';
import TablePaging from '../../../../core/table/TablePaging';
import TableTop from '../../../../core/table/TableTop';
import TableList from '../../../../core/table/TableList';

export const vendorListTableId = 'adminVendorList';

const VendorListTable = (): JSX.Element => {
    const { init } = useVendorListTableInit();
    return init ? <></> : <TableWrapper />;
};

const TableWrapper = (): JSX.Element => {
    const { canEdit, routeToCreate, routeToEdit } = useVendorListStore();
    const { waiting, fltStats, paging, cols, sections, sort, filters, setFilter, setSort, setPaging } =
        useVendorListTableState();
    const { items } = useVendorData();

    if (waiting) {
        ngDelegate.wait(true, true);
        return <></>;
    } else {
        ngDelegate.wait(false, true);
    }

    return (
        <TableList>
            <TableTop
                id={vendorListTableId}
                fltStats={fltStats}
                topRight={
                    canEdit ? (
                        <TableCreateEntityButton
                            id="adminVendorSearch"
                            onClick={routeToCreate}
                        />
                    ) : null
                }
            />
            <table>
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                    onClick={routeToEdit}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default VendorListTable;
